import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/app/[locale]/error.tsx");
